import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ModalWrapper = styled(Column)`
  position: relative;
  width: 620px;
`;

export const Content = styled(Column)`
  padding: 10px 20px 0px 20px;
  background-color: ${({ theme }) => theme.colors.bodyBg};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
